import Forward from "@/views/Forward.vue";

export default (rootPath) => {
  return [
    {
      path: "",
      component: Forward,
      redirect: `${rootPath}/list`,
      hidden: true,
      children: [
        {
          path: "list",
          component: () => import("@/views/table/ActivationsTable.vue"),
          meta: {
            title: "Список активаций музея / площадки",
            activeMenuParent: true,
          },
          hidden: true,
        },
        {
          path: "create/:museumId",
          component: () => import("@/views/forms/ActivationsForm.vue"),
          meta: {
            title: "Создать активацию музея / площадки",
            activeMenuParent: true,
          },
          hidden: true,
        },
        {
          path: "edit/:id",
          component: () => import("@/views/forms/ActivationsForm.vue"),
          meta: {
            title: "Редактировать активацию музея / площадки",
            activeMenuParent: true,
          },
          hidden: true,
        },
      ],
    },
  ];
};
